import { useEffect } from "react";

/**
 * Hält den Bildschirm an, solange der Einkaufsmodus offen ist. Ein Telefon,
 * das im Laden alle dreißig Sekunden dunkel wird, ist im Weg.
 *
 * Die Sperre geht verloren, sobald die App in den Hintergrund wandert, deshalb
 * wird sie bei der Rückkehr neu geholt. Browser ohne Wake Lock (Safari älterer
 * Fassungen) ignorieren das stillschweigend, die App funktioniert weiter.
 */
export function useWakeLock(active: boolean): void {
  useEffect(() => {
    if (!active || !("wakeLock" in navigator)) return;

    let sentinel: WakeLockSentinel | null = null;
    let released = false;

    const request = async () => {
      try {
        sentinel = await navigator.wakeLock.request("screen");
      } catch {
        // Kein Wake Lock, etwa bei niedrigem Akkustand. Kein Grund für einen Fehler.
      }
    };

    const onVisible = () => {
      if (document.visibilityState === "visible" && !released) void request();
    };

    void request();
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      released = true;
      document.removeEventListener("visibilitychange", onVisible);
      void sentinel?.release();
    };
  }, [active]);
}
